/* eslint-disable import/no-extraneous-dependencies */
import Quill from 'quill';

const Break = Quill.import('blots/break');
const Embed = Quill.import('blots/embed');

class SoftBreak extends Break {
  length() {
    return 1;
  }

  value() {
    return '\n';
  }

  insertInto(parent, ref) {
    Embed.prototype.insertInto.call(this, parent, ref);
  }
}

SoftBreak.blotName = 'smartBreak';
SoftBreak.tagName = 'br';

export default SoftBreak;
